import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';

import buildHref from '../utils/buildHref';

const NanoSites = () => {
  const data = useStaticQuery(graphql`
    query {
      allGoogleSpreadsheetRelevantSitesAboutNanotechnology {
        edges {
          node {
            websiteLogo
            description
            link
          }
        }
      }
      statnano: file(relativePath: { eq: "logo_statnano.webp" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      europeancommission: file(relativePath: { eq: "logo_european-commission.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      nanowerk: file(relativePath: { eq: "logo_nanowerk.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      nanospain: file(relativePath: { eq: "logo_nanospain.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      nanora: file(relativePath: { eq: "logo_nanora.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      enna: file(relativePath: { eq: "logo_enna.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      nanoall: file(relativePath: { eq: "logo_nano2all.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      gonano: file(relativePath: { eq: "logo_gonano.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  const gsheet = data.allGoogleSpreadsheetRelevantSitesAboutNanotechnology.edges;

  return (
    <Layout>
      <SEO title="Relevant sites about nanotechnology" />
      <h1>Other sites of interest</h1>
      <div className="sites-list">
        { gsheet.map((element, idx) => (
          <div key={ `wrapper-${idx * 1}` } className="sites-item">
            <a href={ buildHref(element.node.link) } rel="noopener noreferrer" target="_blank">
              <img src={ data[element.node.websiteLogo].childImageSharp.fluid.src } alt="" />
              <span>{ element.node.description }</span>
            </a>
          </div>
        )) }
      </div>
    </Layout>
  );
};

export default NanoSites;
